import { FilterGroupState } from "features/ui/Filters/FilterBuilder/types";
import { FilterOperator } from "features/ui/Filters/types";

// Events the API puts in no group at all, because they have no value for the grouping attribute.
export const createUngroupedAttributeFilter = (
  attribute: string
): FilterGroupState => ({
  type: "group",
  id: "ungrouped-attribute-filter",
  anyAll: "all",
  children: [
    {
      type: "row",
      id: "ungrouped-attribute-filter-row",
      attribute,
      operator: FilterOperator.IS_EMPTY,
      values: ["null"],
    },
  ],
});

// Scopes events to one attribute group. IN covers both kinds of grouping attribute: on a
// multi-valued one it matches every event carrying that value.
export const createAttributeGroupEventFilter = (
  attribute: string,
  groupName: string
): FilterGroupState => ({
  type: "group",
  id: `attribute-group-${attribute}`,
  anyAll: "all",
  children: [
    {
      type: "row",
      id: `attribute-group-${attribute}-value`,
      attribute,
      operator: FilterOperator.IN,
      values: [groupName],
    },
  ],
});
